//React
import { useState, useEffect, Fragment } from "react";

//Chakra
import {
  SimpleGrid,
  VStack,
  Box,
  Text,
  Flex,
  Button,
  Center,
  HStack,
  Stack,
  Heading,
  Icon,
} from "@chakra-ui/react";

//Custom Component
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody.js";

//Endpoint
import { getOrderDetails } from "service/order.service";
import CardBadge from "components/Card/CardBadge.js";
import moment from "moment";
import OrderTransactionForm from "./orderTransactionForm";
import {
  BsArrowDownRightCircle,
  BsArrowRightSquare,
  BsCheck2Circle,
  BsExclamation,
} from "react-icons/bs";
import { BiX } from "react-icons/bi";
import { CheckIcon } from "@chakra-ui/icons";

//Package
const {
  useHistory,
  useLocation,
  useParams,
} = require("react-router-dom/cjs/react-router-dom.min");

export default function orderDetail() {
  // variable
  const history = useHistory();
  const location = useLocation();
  const route_param = useParams();

  const [order, setOrder] = useState({});
  const [selectedAttendanceId, setSelectedAttendanceId] = useState(
    location?.state ?? null
  );
  const [transaction, setTransaction] = useState({
    status: false,
    type: "gigger",
    price: 0,
    is_referral: false,
    is_refund: false,
  });

  //methods

  const getOrder = async (route_param, orderAttendanceId) => {
    try {
      const { data } = await getOrderDetails(route_param, orderAttendanceId);

      if (data) {
        let newArr = [];

        newArr = data.order_attendances.filter((attendance) => {
          if (attendance.id === parseInt(orderAttendanceId)) {
            return attendance;
          }
        });

        data.order_attendances = [...newArr];

        setOrder(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [showReport, setShowReport] = useState(false);

  //setup
  useEffect(() => {
    getOrder(route_param.orderId, selectedAttendanceId);
  }, []);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {!transaction.status ? (
        <>
          <Box
            textColor={"white"}
            position={"fixed"}
            top={"50%"}
            right={"50px"}
            zIndex={"10"}
            alignSelf={"flex-end"}
            w={"max"}
            bg={"WindowText"}
            rounded={"3xl"}
            py={"2"}
            px={"4"}
          >
            <Flex fontSize={"xl"} justifyContent={"end"} gap={"2"}>
              {order?.is_report_resolved ? (
                <Icon as={CheckIcon} my={"auto"} color={"green"} h={"5"} w={"5"} />
              ) : order?.order_reports && order?.order_reports?.length > 0 ? (
                <Icon as={BsExclamation} my={"auto"} color={"red"} h={"10"} w={"10"} />
              ) : (
                <Icon as={BsCheck2Circle} my={"auto"} color={"green"} />
              )}
              <Text my={"auto"}>
                {order?.order_reports && order?.order_reports?.length < 1
                  ? "No"
                  : order?.order_reports?.length}
              </Text>
              <Text my={"auto"}>Report</Text>
            </Flex>
            <Stack>
              {order?.order_reports &&
                order?.order_reports.map((report) => {
                  return (
                    <Flex gap={"2"} my={"2"} key={report.id} justifyContent={"end"}>
                      <Flex gap={"2"}>
                        {report.is_resolved ? (
                          <Icon as={BsCheck2Circle} my={"auto"} color={"green"} />
                        ) : (
                          <Icon as={BiX} my={"auto"} color={"red"} />
                        )}
                        <Text
                          key={report.id}
                          color={!report.is_resolved ? "red" : "white"}
                          fontWeight={!report.is_resolved ? "bold" : "light"}
                        >
                          {!report.is_resolved && "Not"} Resolved
                        </Text>
                      </Flex>

                      <Icon
                        as={BsArrowRightSquare}
                        my={"auto"}
                        color={"yellow"}
                        _hover={{ cursor: "pointer" }}
                        onClick={() => {
                          history.push({
                            pathname: `/admin/report/detail`,
                            state: report,
                          });
                        }}
                      />
                    </Flex>
                  );
                })}
            </Stack>
          </Box>
          <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
            <CardHeader p="6px 0px 22px 0px">
              <Text
                fontSize="lg"
                color="#fff"
                fontWeight="bold"
                textColor={"cyan.300"}
                textTransform={"uppercase"}
              >
                Hirer
              </Text>
            </CardHeader>
            <CardBody w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Full Name</Text>
                  <CardBadge props={order?.hirer?.full_name} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>User Name</Text>
                  <CardBadge props={order?.hirer?.username} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Email </Text>
                  <CardBadge props={order?.hirer?.contact_email} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Contact No.</Text>
                  <CardBadge props={order?.hirer?.contact_phone} />
                </VStack>
                {order?.hirer?.bank_information.length > 0 ? (
                  order?.hirer?.bank_information.map((bank, index) => {
                    return (
                      <Stack key={index}>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Bank {index + 1}</Text>
                          <CardBadge props={bank?.bank_name} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Bank {index + 1} Account No.</Text>
                          <CardBadge props={bank?.account_no} />
                        </VStack>
                      </Stack>
                    );
                  })
                ) : (
                  <>
                    <VStack alignItems={"start"} my={"3"}>
                      <Text color={"white"}>Bank</Text>
                      <CardBadge props={"No Bank Details"} />
                    </VStack>
                    <VStack alignItems={"start"} my={"3"}>
                      <Text color={"white"}>Bank Account No.</Text>
                      <CardBadge props={"No Bank Details"} />
                    </VStack>
                  </>
                )}
                {order?.order_attendances?.length < 1 && (
                  <Button
                    isDisabled={
                      (order.order_status !== "Refund") ||
                      (order.payment_release_status == "completed")
                    }
                    variant="brand"
                    fontSize="10px"
                    type="submit"
                    w="40%"
                    maxW="350px"
                    h="45"
                    mb="20px"
                    mt="20px"
                    mx={"2"}
                    textTransform={"uppercase"}
                    fontWeight={"bold"}
                    backgroundColor={"blue.500"}
                    onClick={() => {
                      setTransaction({
                        status: true,
                        type: "user",
                        price: order.order_price_details.orderable_price,
                        is_refund: 1,
                        is_referral: 0,
                      });
                    }}
                  >
                    Refund to user
                  </Button>
                )}
              </SimpleGrid>
            </CardBody>
          </Card>
          <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
            <CardHeader p="6px 0px 22px 0px">
              <Text
                fontSize="lg"
                color="#fff"
                fontWeight="bold"
                textColor={"limegreen"}
                textTransform={"uppercase"}
              >
                Gigger
              </Text>
            </CardHeader>
            <CardBody w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Full Name</Text>
                  <CardBadge props={order?.gigger?.full_name} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>User Name</Text>
                  <CardBadge props={order?.gigger?.username} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Email </Text>
                  <CardBadge props={order?.gigger?.contact_email} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Contact No.</Text>
                  <CardBadge props={order?.gigger?.contact_phone} />
                </VStack>

                {order?.gigger?.bank_information.length > 0 ? (
                  order?.gigger?.bank_information.map((bank, index) => {
                    return (
                      <Stack key={index}>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Bank {index + 1}</Text>
                          <CardBadge props={bank?.bank_name} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Bank {index + 1} Account No.</Text>
                          <CardBadge props={bank?.account_no} />
                        </VStack>
                        {order.order_attendances.length < 1 && (
                          <Button
                            isDisabled={order.payment_release_status == "completed" || order.order_status == 'Refund' }
                            variant="brand"
                            fontSize="10px"
                            type="submit"
                            w="40%"
                            maxW="350px"
                            h="45"
                            mb="20px"
                            mt="20px"
                            mx={"2"}
                            textTransform={"uppercase"}
                            fontWeight={"bold"}
                            backgroundColor={"green.500"}
                            onClick={() => {
                              setTransaction({
                                status: true,
                                type: "gigger",
                                price: order.order_price_details.total_payment_gigger,
                              });
                            }}
                          >
                            Release to gigger
                          </Button>
                        )}
                      </Stack>
                    );
                  })
                ) : (
                  <>
                    <VStack alignItems={"start"} my={"3"}>
                      <Text color={"white"}>Bank</Text>
                      <CardBadge props={"No Bank Details"} />
                    </VStack>
                    <VStack alignItems={"start"} my={"3"}>
                      <Text color={"white"}>Bank Account No.</Text>
                      <CardBadge props={"No Bank Details"} />
                    </VStack>
                  </>
                )}
              </SimpleGrid>
            </CardBody>
          </Card>
          {order?.referral ? (
            <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
              <CardHeader p="6px 0px 22px 0px">
                <Text
                  fontSize="lg"
                  color="#fff"
                  fontWeight="bold"
                  textColor={"beige"}
                  textTransform={"uppercase"}
                >
                  Referral
                </Text>
              </CardHeader>
              <CardBody w={"full"}>
                <SimpleGrid columns={2} w={"full"}>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Full Name</Text>
                    <CardBadge props={order?.referral?.full_name} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>User Name</Text>
                    <CardBadge props={order?.referral?.username} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Email </Text>
                    <CardBadge props={order?.referral?.contact_email} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Contact No.</Text>
                    <CardBadge props={order?.referral?.contact_phone} />
                  </VStack>

                  {order?.referral?.bank_information.length > 0 ? (
                    order?.referral?.bank_information.map((bank, index) => {
                      return (
                        <Fragment key={index}>
                          <VStack alignItems={"start"} my={"3"}>
                            <Text color={"white"}>Bank {index + 1}</Text>
                            <CardBadge props={bank?.bank_name} />
                          </VStack>
                          <VStack alignItems={"start"} my={"3"}>
                            <Text color={"white"}>Bank {index + 1} Account No.</Text>
                            <CardBadge props={bank?.account_no} />
                          </VStack>
                          <VStack alignItems={"start"} my={"3"}>
                            <Text color={"white"}>Payment Status</Text>
                            <CardBadge props={order?.referrer_payment_status} />
                          </VStack>
                          <VStack alignItems={"start"} my={"3"}>
                            <Text color={"white"}>Payment Total (RM)</Text>
                            <CardBadge props={order?.referrer_payment_total} />
                          </VStack>
                        </Fragment>
                      );
                    })
                  ) : (
                    <>
                      <VStack alignItems={"start"} my={"3"}>
                        <Text color={"white"}>Bank</Text>
                        <CardBadge props={"No Bank Details"} />
                      </VStack>
                      <VStack alignItems={"start"} my={"3"}>
                        <Text color={"white"}>Bank Account No.</Text>
                        <CardBadge props={"No Bank Details"} />
                      </VStack>
                    </>
                  )}

                  <Button
                    isDisabled={order.referrer_payment_status !== "incomplete"}
                    variant="brand"
                    fontSize="10px"
                    type="submit"
                    w="40%"
                    maxW="350px"
                    h="45"
                    mb="20px"
                    mt="20px"
                    mx={"2"}
                    textTransform={"uppercase"}
                    fontWeight={"bold"}
                    bgColor={"blue.100"}
                    textColor={"black"}
                    onClick={() => {
                      setTransaction({
                        status: true,
                        type: "referral",
                        is_referral: true,
                        is_refund: false,
                        price: order.referrer_payment_total,
                      });
                    }}
                  >
                    Release to referral
                  </Button>
                </SimpleGrid>
              </CardBody>
            </Card>
          ) : (
            <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
              <CardHeader p="6px 0px 22px 0px">
                <Text
                  fontSize="lg"
                  color="#fff"
                  fontWeight="bold"
                  textColor={"beige"}
                  textTransform={"uppercase"}
                >
                  Referral
                </Text>
              </CardHeader>
              <CardBody w={"full"}>
                <SimpleGrid columns={2} w={"full"}>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Full Name</Text>
                    <CardBadge props={"-"} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>User Name</Text>
                    <CardBadge props={"-"} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Email </Text>
                    <CardBadge props={"-"} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Contact No.</Text>
                    <CardBadge props={"-"} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Bank </Text>
                    <CardBadge props={"-"} />
                  </VStack>
                  <VStack alignItems={"start"} my={"3"}>
                    <Text color={"white"}>Bank Account No.</Text>
                    <CardBadge props={"-"} />
                  </VStack>
                </SimpleGrid>
              </CardBody>
            </Card>
          )}
          <Card overflowX={{ sm: "scroll", xl: "hidden" }} my={"4"}>
            <CardHeader p="6px 0px 22px 0px">
              <Text
                fontSize="lg"
                color="#fff"
                fontWeight="bold"
                textColor={"pink.400"}
                textTransform={"uppercase"}
              >
                Order
              </Text>
            </CardHeader>
            <CardBody w={"full"}>
              <SimpleGrid columns={2} w={"full"}>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Order Status</Text>
                  <CardBadge
                    props={
                      order?.order_status == "to_review"
                        ? "completed"
                        : order?.order_status
                    }
                  />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Billplz Reference: Order Payment No. </Text>
                  <CardBadge props={order?.transactions?.payment_no} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Billplz Reference: Order Bill Code</Text>
                  <CardBadge props={order?.transactions?.gateway_bill_code} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Gigs Reference: Order No</Text>
                  <CardBadge props={order?.order_no} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Paid Date</Text>
                  <CardBadge
                    props={
                      order?.pay_date?.created_at
                        ? moment(order?.pay_date?.created_at).format("YYYY-MM-DD")
                        : ""
                    }
                  />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Service Price (RM)</Text>
                  <CardBadge props={order?.order_price_details?.orderable_price} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>5% Surcharge - Hirer (RM)</Text>
                  <CardBadge props={order?.order_price_details?.surcharge_hirer} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Payment Made by Hirer (RM)</Text>
                  <CardBadge props={order?.order_price_details?.total_payment_hirer} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>5% Surcharge - Gigger (RM)</Text>
                  <CardBadge props={order?.order_price_details?.surcharge_gigger} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>Settlement for Gigger (RM)</Text>
                  <CardBadge props={order?.order_price_details?.total_payment_gigger} />
                </VStack>
                <VStack alignItems={"start"} my={"3"}>
                  <Text color={"white"}>2% Referral (RM)</Text>
                  <CardBadge props={order?.order_price_details?.total_payment_referral} />
                </VStack>
              </SimpleGrid>
            </CardBody>
          </Card>
          {order?.order_attendances &&
            order?.order_attendances.map((attendance) => {
              return (
                <Card
                  overflowX={{ sm: "scroll", xl: "hidden" }}
                  my={"4"}
                  key={attendance.id}
                >
                  <CardHeader p="6px 0px 22px 0px">
                    <Text
                      fontSize="lg"
                      color="#fff"
                      fontWeight="bold"
                      textColor={"crimson"}
                      textTransform={"uppercase"}
                    >
                      Order Attendance
                    </Text>
                  </CardHeader>
                  <CardBody w={"full"}>
                    <Stack w={"full"}>
                      <SimpleGrid columns={{ base: 1, md: 2 }} w={"full"}>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Title</Text>
                          <CardBadge props={attendance.title} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Description</Text>
                          <CardBadge props={attendance.description} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Price (RM)</Text>
                          <CardBadge props={attendance.price} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Payment Total Gigger (RM)</Text>
                          <CardBadge props={attendance.price_to_released} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Status</Text>
                          <CardBadge props={attendance.status} />
                        </VStack>
                        <VStack alignItems={"start"} my={"3"}>
                          <Text color={"white"}>Payment Release Status</Text>
                          <CardBadge props={attendance.payment_release_status} />
                        </VStack>
                      </SimpleGrid>

                      <HStack gap={"10"}>
                        <Button
                          isDisabled={
                            attendance.status != "Processing" ||
                            attendance.payment_release_status == "completed"
                          }
                          variant="brand"
                          fontSize="10px"
                          type="submit"
                          w="40%"
                          maxW="350px"
                          h="45"
                          mb="20px"
                          mt="20px"
                          mx={"2"}
                          textTransform={"uppercase"}
                          fontWeight={"bold"}
                          backgroundColor={"green.500"}
                          onClick={() => {
                            setTransaction({
                              status: true,
                              type: "gigger",
                              price: attendance.price,
                            });
                          }}
                        >
                          Release to gigger
                        </Button>
                        <Button
                          isDisabled={
                            attendance.status != "Failed" ||
                            attendance.payment_release_status == "completed"
                          }
                          variant="brand"
                          fontSize="10px"
                          type="submit"
                          w="40%"
                          maxW="350px"
                          h="45"
                          mb="20px"
                          mt="20px"
                          mx={"2"}
                          textTransform={"uppercase"}
                          fontWeight={"bold"}
                          backgroundColor={"blue.500"}
                          onClick={() => {
                            setTransaction({
                              status: true,
                              type: "user",
                              price: attendance.price,
                              is_refund: 1,
                              is_referral: 0,
                            });
                          }}
                        >
                          Refund to user
                        </Button>
                      </HStack>
                    </Stack>
                  </CardBody>
                </Card>
              );
            })}
        </>
      ) : (
        <OrderTransactionForm
          order={order}
          invoice_type={transaction.type}
          price={transaction.price}
          is_referral={transaction.is_referral}
          is_refund={transaction.is_refund}
          setTransactionMethod={setTransaction}
        />
      )}
    </Flex>
  );
}
